var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('map-section',{staticClass:"map-section-module",attrs:{"markers":_vm.attributes.markers}})}
var staticRenderFns = []

export { render, staticRenderFns }